import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("staff_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default api;

export const STATUS_LABELS = {
    booked: "Booked",
    arrived: "Arrived",
    in_progress: "In Progress",
    completed: "Completed",
    no_show: "No-show",
    cancelled: "Cancelled",
};

export const SOURCE_LABELS = {
    online: "Online",
    walk_in: "Walk-in",
    staff: "Staff",
};

export function formatDateISO(d) {
    const year = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${m}-${day}`;
}

export function formatTimePretty(hhmm) {
    const [h, m] = hhmm.split(":").map(Number);
    const period = h >= 12 ? "PM" : "AM";
    const hour12 = ((h + 11) % 12) + 1;
    return `${hour12}:${String(m).padStart(2, "0")} ${period}`;
}
